// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* public/apps/engineering-exact/App.css */

* {
    box-sizing: border-box;
}
  
body {
    font-family: 'Inter', Arial, sans-serif;
    background-color: #f0f0f0;
    margin: 0;
    line-height: 1.6;
    color: #333333;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.container {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    /* background-color: #282828; */
    /* max-width: 2000px; */
}

.row {
    width: 100%;
    padding: 0 2rem;
    display: flex;
    justify-content: center;
}

.column {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin-right: auto;
    margin-left: auto;
    animation: fadeIn 0.6s ease-out;
}

.column-2 {
    margin: auto;
}

.font-blue {
    color: #4545C4;
}

.font-orange {
    color: #FF743D;
}

.font-green {
    color: #2EC182;
}

.style-dark-button {
    background-color: #020202;
    border: none;
    border-radius: 2rem;
    font-size: 20px;
    padding: 1rem;
    font-weight: 600;
    text-decoration: none;
    color: #fff;
    display: inline-block;  
    /* margin: 2rem 0; */
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.style-dark-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.blue-button:hover {
    background-color: #4545C4;
}

.orange-button:hover {
    background-color: #FF743D;
}

.green-button:hover {
    background-color: #2EC182;
}

.background-blue {
    background: linear-gradient(145deg, #4545C4, #3939b0);
}

.background-orange {
    background: linear-gradient(145deg, #FF743D, #ff6024);
}

.background-green {
    background: linear-gradient(145deg, #2EC182, #25a46f);
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

h1 {
    font-size: clamp(2rem, 5vw, 3rem);
    font-weight: 700;
    letter-spacing: -0.02em;
}

h2 {
    font-size: clamp(1.5rem, 4vw, 2.5rem);
    font-weight: 600;
    margin-bottom: 1.5rem;
}

p {
    font-size: 1.125rem;
    line-height: 1.8;
    color: #4a4a4a;
}

/* Add glass morphism effect */
.glass-effect {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 1rem;
}

/* Smooth scrolling */
html {
    scroll-behavior: smooth;
}

.loading-skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
}

@keyframes loading {
    from { background-position: 200% 0; }
    to { background-position: -200% 0; }
}

/* Card hover effects */
.card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./App.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;IACI,sBAAsB;AAC1B;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,uBAAuB;AAC3B;;AAEA;IACI,yEAAyE;IACzE,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,OAAO,2BAA2B,EAAE;IACpC,KAAK,4BAA4B,EAAE;AACvC;;AAEA,uBAAuB;AACvB;IACI,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C","sourcesContent":["/* public/apps/engineering-exact/App.css */\n\n* {\n    box-sizing: border-box;\n}\n  \nbody {\n    font-family: 'Inter', Arial, sans-serif;\n    background-color: #f0f0f0;\n    margin: 0;\n    line-height: 1.6;\n    color: #333333;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.container {\n    width: 100%;\n    height: 100vh;\n    margin: 0 auto;\n    /* background-color: #282828; */\n    /* max-width: 2000px; */\n}\n\n.row {\n    width: 100%;\n    padding: 0 2rem;\n    display: flex;\n    justify-content: center;\n}\n\n.column {\n    display: flex;\n    flex-direction: column;\n    width: 80%;\n    margin-right: auto;\n    margin-left: auto;\n    animation: fadeIn 0.6s ease-out;\n}\n\n.column-2 {\n    margin: auto;\n}\n\n.font-blue {\n    color: #4545C4;\n}\n\n.font-orange {\n    color: #FF743D;\n}\n\n.font-green {\n    color: #2EC182;\n}\n\n.style-dark-button {\n    background-color: #020202;\n    border: none;\n    border-radius: 2rem;\n    font-size: 20px;\n    padding: 1rem;\n    font-weight: 600;\n    text-decoration: none;\n    color: #fff;\n    display: inline-block;  \n    /* margin: 2rem 0; */\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.style-dark-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.blue-button:hover {\n    background-color: #4545C4;\n}\n\n.orange-button:hover {\n    background-color: #FF743D;\n}\n\n.green-button:hover {\n    background-color: #2EC182;\n}\n\n.background-blue {\n    background: linear-gradient(145deg, #4545C4, #3939b0);\n}\n\n.background-orange {\n    background: linear-gradient(145deg, #FF743D, #ff6024);\n}\n\n.background-green {\n    background: linear-gradient(145deg, #2EC182, #25a46f);\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(20px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\nh1 {\n    font-size: clamp(2rem, 5vw, 3rem);\n    font-weight: 700;\n    letter-spacing: -0.02em;\n}\n\nh2 {\n    font-size: clamp(1.5rem, 4vw, 2.5rem);\n    font-weight: 600;\n    margin-bottom: 1.5rem;\n}\n\np {\n    font-size: 1.125rem;\n    line-height: 1.8;\n    color: #4a4a4a;\n}\n\n/* Add glass morphism effect */\n.glass-effect {\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 1rem;\n}\n\n/* Smooth scrolling */\nhtml {\n    scroll-behavior: smooth;\n}\n\n.loading-skeleton {\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n    from { background-position: 200% 0; }\n    to { background-position: -200% 0; }\n}\n\n/* Card hover effects */\n.card {\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
